module.exports = __webpack_public_path__ + "img/banner.ff3e1273.png";